import { Trans } from "react-i18next";
import {
  ContactSupportOption,
  CoreChatComponent,
  useChatStyles,
  useContactSupportDetails,
} from "@b2bportal/core-chat";
import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import clsx from "clsx";

import defaultStyles from "./ContactSupportDetails.module.scss";

export interface IContactSupportDetailsProps {
  onStartChat: () => void;
}

export const ContactSupportDetails = (props: IContactSupportDetailsProps) => {
  const COMPONENT_KEY = CoreChatComponent.ContactSupportDetails;
  const styles = useChatStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);
  const { context, text } = useContactSupportDetails();

  return (
    <div className={clsx(block)}>
      <span className={cn("title")}>{text.contactSupportTitle}</span>
      <span className={cn("subtitle")}>{text.contactSupportSubtitle}</span>
      {context.hideSupportIdInContactSupport ? null : (
        <div className={cn("support-id-container")}>
          <span className={cn("support-id-label")}>{text.supportIdLabel}</span>
          {context.supportId == null ? null : (
            <span className={cn("support-id")}>{context.supportId}</span>
          )}
        </div>
      )}
      <div className={cn("contact-options-container")}>
        {context.showChatOption && (
          <ContactSupportOption
            icon={IconNameEnum.support__chat}
            onClick={props.onStartChat}
            subtitles={text.chatOptionSubtitle}
            title={text.chatOptionTitle}
          />
        )}
        <ContactSupportOption
          disabled={!context.enableCallOption}
          icon={IconNameEnum.support__phone}
          onClick={() => window.open(`tel:${context.supportNumber}`, "_self")}
          subtitles={[
            <span>{text.callOptionSubtitle}</span>,
            <span>{text.callOptionLocalSubtitle}</span>,
          ]}
          title={text.callOptionLocalTitle}
        />
        {context.intlSupportNumber == null ? null : (
          <ContactSupportOption
            disabled={!context.enableCallOption}
            icon={IconNameEnum.support__phoneIntl}
            onClick={() =>
              window.open(`tel:${context.intlSupportNumber}`, "_self")
            }
            subtitles={[
              <span>{text.callOptionSubtitle}</span>,
              <span>{text.callOptionIntlSubtitle}</span>,
            ]}
            title={text.callOptionIntlTitle}
          />
        )}
      </div>
      {context.helpCenterBaseUrl != null && !context.hideFaqLinks && (
        <div className={cn("faq-link-container")}>
          <Trans
            i18nKey={"chat.additionalInfo"}
            components={[
              <span />,
              // eslint-disable-next-line jsx-a11y/anchor-has-content
              <a
                className={clsx("help-link", styles.helpLink)}
                href={context.helpCenterBaseUrl}
                rel="noopener noreferrer"
                target="_blank"
              />,
            ]}
          />
        </div>
      )}
    </div>
  );
};
